import type { BeforeErrorHook } from "ky";
import { isHTTPError } from "ky";

import { DENY_LIST_EXCEPTION_TYPE } from "@/constants/errorCode";
import { logOut } from "@/redux/actions/logout";
import store from "@/redux/store";

// store.dispatch is typed as Dispatch<AnyAction> but auth actions are thunks
const dispatch: (action: any) => any = store.dispatch;

export type ServerError = {
  [key: string]: any;
  message?: string;
};

export const errorShapeHook: BeforeErrorHook = ({ error }) => {
  if (!isHTTPError(error)) return error;

  const serverError = ((error.data as { error?: ServerError } | null)?.error ?? {}) as ServerError;
  const { type } = serverError;

  // Normalize error shape for callers — consumed by errorToastHook and callers
  Object.assign(error, { cleanError: serverError });

  if (type === DENY_LIST_EXCEPTION_TYPE) {
    dispatch(logOut());
  }

  return error;
};
